export default "__VITE_ASSET__BmX1yN4o__"